export default {
  title: 'USER TYPE',
  subtitle: 'Are you a coaching provider or a client?',
  link: {
    coach: 'Create, sell, manage and grow your coaching business.',
    client: 'Download and subscribe to health and fitness programs.',
  },
};
